import './wave-functions';
import './modal';

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
